import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Alert, CircularProgress, Button, Paper } from '@mui/material';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { useAcceptCoInvestmentInvitation } from '@/lib/api/investments';

const AcceptCoInvestmentPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const acceptInvitation = useAcceptCoInvestmentInvitation();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage('Token de invitación no proporcionado');
      return;
    }

    acceptInvitation.mutate(
      { token },
      {
        onSuccess: () => {
          setStatus('success');
        },
        onError: (error: unknown) => {
          setStatus('error');
          const axiosError = error as { response?: { data?: { message?: string } } };
          setErrorMessage(
            axiosError?.response?.data?.message ||
              'Error al aceptar la invitación. Revisa que el email del usuario actual corresponda con el de la invitación.'
          );
        },
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4, textAlign: 'center' }}>
        {status === 'loading' && (
          <Box>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="h6">Aceptando invitación...</Typography>
          </Box>
        )}

        {status === 'success' && (
          <Box>
            <CheckCircleOutline color="success" sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h5" fontWeight={600} gutterBottom>
              Invitación aceptada
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Ya puedes ver la co-inversión en tu listado de inversiones.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/inversiones')}>
              Ir a mis inversiones
            </Button>
          </Box>
        )}

        {status === 'error' && (
          <Box>
            <ErrorOutline color="error" sx={{ fontSize: 64, mb: 2 }} />
            <Typography variant="h5" fontWeight={600} gutterBottom>
              Error
            </Typography>
            <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
              {errorMessage}
            </Alert>
            <Button variant="contained" onClick={() => navigate('/inversiones')}>
              Ir a mis inversiones
            </Button>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default AcceptCoInvestmentPage;
